import axiosInstance from "./axiosInstance";

// Get all posts
export const fetchCategory = async () => {
  const response = await axiosInstance.get("/category/getall");
  return response.data;
};



// Get post by ID
export const getCategoryById = async (id) => {
  const response = await axiosInstance.get(`/category/get?postId=${id}`);
  return response.data;
};
// Create a new post
export const createCategory = async (data) => {
  const response = await axiosInstance.post("/category", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

// Update a post
export const updateCategory = async ({ data }) => {
  const response = await axiosInstance.put(`/category}`, data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
  return response.data;
};

// Delete a post
export const deleteCategory = async (id) => {
  await axiosInstance.delete(`/category/${id}`);
};

